import React, { useEffect, useRef } from "react";

const MasterDataManagement = () => {
  const token = Digit.UserService.getUser().access_token;
  const currentHeader = process.env.REACT_APP_MASTER_DATA_DOMAIN || "";
  console.log("currentHeader", currentHeader);

  const url = `${currentHeader}?token=${token}`;

  return (
    <div className="master-data-container">
      <iframe className="fastPas-iframe" src={url} title="Document Viewer"></iframe>
    </div>
  );
};

export default MasterDataManagement;
